import type { AccountOrder } from '../../core/types/account'

/** Kleur van het statuslabel van een bestelling (Bestellingen en Thuis). */
const tones: Record<string, string> = {
  'In behandeling': 'bg-blush/70 text-ink',
  // clay/10 als vlak houdt clay-tekst op ≥ 4,5:1.
  Onderweg: 'bg-clay/10 text-clay',
  Bezorgd: 'bg-sage/15 text-ink',
}
const DEFAULT_TONE = 'bg-sand text-ink'

/** Wat de klant ziet: geannuleerd en "per mail" (alleen cadeaubonnen) gaan voor de verzendstatus. */
export const orderStatusLabel = (o: AccountOrder, giftOnly: boolean) => (o.cancelledAt ? 'Geannuleerd' : giftOnly ? 'Per mail' : o.status)

export const orderStatusTone = (label: string) => tones[label] ?? DEFAULT_TONE
